import React from 'react';
import { Route, Router } from 'react-router-dom';
import { LocalizeProvider } from "react-localize-redux";
import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk';
import { Provider } from 'react-redux'
import { routerMiddleware } from 'react-router-redux';
import reducer from '../reducers'
import history from '../routes/history';

import SignUpPageAdmin from '../components/Admin/SignUpPageAdmin.js';
import AdminHome from '../components/Admin/Home/AdminHome.js';
import AdminAddCategory from '../components/Admin/Category/CategoryAdd.js';
import AdminListCategory from '../components/Admin/Category/CategoryList.js';
import AllUsersList from '../components/Admin/User/AllUsersList.js';
import JobSeekersUser from '../components/Admin/User/JobSeekersUser.js';
import AdminContactUsList from '../components/Admin/Contact/ContactUsList.js';
import GetInTouchContact from '../components/Admin/Contact/GetInTouchContact.js';
import ErrorPage from '../components/Inc/Error404.js';

import AdminAddCity from '../components/Admin/City/AddCity.js';
import AdminViewCity from '../components/Admin/City/ViewCity.js';
import AdminAddBlog from '../components/Admin/Blog/Add.js';
import AdminListBlog from '../components/Admin/Blog/List.js';
import ResumeActivityList from '../components/Admin/Resume/ResumeActivityList.js';

const historyMiddleware = routerMiddleware(history);
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = createStore(
    reducer,
    composeEnhancers(
        applyMiddleware(historyMiddleware, thunk)
    )
)

export const superAdminRoutes = () => {
    return (
        <Provider store={store}>
            <Router history={history}  >                
                <div className="routesBox">
                    <LocalizeProvider>
                        <Route exact path="/admin/"  render={(props) => <SignUpPageAdmin {...props} />}/>                 
                        <Route exact path="/admin/home"  render={(props) => <AdminHome {...props} />}/>                 
                        <Route exact path="/admin/category-add/"  render={(props) => <AdminAddCategory {...props} />}/>                 
                        <Route exact path="/admin/category-edit/"  render={(props) => <AdminAddCategory {...props} />}/>                 
                        <Route exact path="/admin/category/"  render={(props) => <AdminListCategory {...props} />}/>                 
                        <Route exact path="/admin/jobProvider/"  render={(props) => <AllUsersList {...props} />}/>                 
                        <Route exact path="/admin/jobSeekers/"  render={(props) => <JobSeekersUser {...props} />}/>                 
                        <Route exact path="/admin/contact-us/"  render={(props) => <AdminContactUsList {...props} />}/>                 
                        <Route exact path="/admin/getIntouch-contact/"  render={(props) => <GetInTouchContact {...props} />}/>                 
                        <Route exact path="/admin/add-city/"  render={(props) => <AdminAddCity {...props} />}/>                 
                        <Route exact path="/admin/view-city/"  render={(props) => <AdminViewCity {...props} />}/>                 
                        <Route exact path="/admin/blog-add/"  render={(props) => <AdminAddBlog {...props} />}/>                 
                        <Route exact path="/admin/blog-edit/:id"  render={(props) => <AdminAddBlog {...props} />}/>                 
                        <Route exact path="/admin/blog-list/"  render={(props) => <AdminListBlog {...props} />}/>                 
                        <Route exact path="/admin/resume-list"  render={(props) => <ResumeActivityList {...props} />}/>                 
                        <Route exact path="/error"  render={(props) => <ErrorPage {...props} />}/>                 
                     
                    </LocalizeProvider>
                </div>
            </Router>
        </Provider>
    );
}


// WEBPACK FOOTER //
// ./src/routes/routesSuperAdmin.js